module.exports = __webpack_public_path__ + "static/media/Accademia - DK Grey_LT Grey.aef7f479.jpg";